export const ADD_TRANSACTION = 'ADD_TRANSACTION'
export const CLEAR_TRANSACTIONS = 'CLEAR_TRANSACTIONS'
